var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarcodeOutline = function SvgBarcodeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20,
    stroke: props.fill,
    strokeDasharray: "1 6",
    strokeLinecap: "round"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#626663",
    clipPath: "url(#barcode-outline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.667,
    d: "M11.834 11.5v19M29.834 11.5v19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11.5v19M22.5 11.5v19"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.667,
    d: "M15.333 11.5v19M25.333 11.5v19M27.333 11.5v19M17.334 11.5v19"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "barcode-outline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.5 9.5h22v22h-22z"
  })))));
};
export default SvgBarcodeOutline;